<div class="padding">
  <form [formGroup]="searchCriteriaDetails">
    <div class="flex-container">
      <div class="flex-item form-field">
        <mat-radio-group [formControlName]="'businessSearchCriteriaTypeID'" name="business-search-criteria-type"
          [attr.aria-label]="'orders.nameOrNumberSearchRadioOption' | transloco">
          <mat-radio-button class="radio-button" [value]="nameSearch">{{ 'orders.nameSearch' | transloco }}</mat-radio-button>
          <mat-radio-button class="radio-button" [value]="numberSearch">{{ 'orders.numberSearch' | transloco }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="flex-container">
      @if (displayNameSearchFields) {
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.name' | transloco }}</mat-label>
            <input matInput [formControlName]="'name'" name="name" [placeholder]="'common.labels.name' | transloco">
          </mat-form-field>
          <lib-error-bubble [control]="searchCriteriaDetails.get('name')!"
          [message]="nameError$"></lib-error-bubble>
        </div>
      }

      @if (displayNumberSearchFields) {
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.businessOrCorporateRegistrationNumber' | transloco }}</mat-label>
            <input matInput [formControlName]="'number'" name="number"
              [placeholder]="'orders.businessOrCorporateRegistrationNumber' | transloco">
          </mat-form-field>
          <lib-error-bubble [control]="searchCriteriaDetails.get('number')!"
          [message]="numberError$"></lib-error-bubble>
        </div>
      }
    </div>
    <mat-expansion-panel [expanded]="false" class="mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title class="bold">
          {{ 'common.labels.jurisdictions' | transloco }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <button color="primary" [disabled]="getSelectedJurisdictions().length == jurisdictions.length"
      class="padding-bottom" mat-flat-button (click)="selectAllToggles()">{{ 'orders.selectAll' | transloco }}</button>
      <button [disabled]="getSelectedJurisdictions().length == 0" mat-flat-button (click)="deselectAllToggles()"
      class="margin-left-5">{{ 'orders.deselectAll' | transloco }}</button>

      <div class="jurisdiction-container padding-top">
        @for (jurisdiction of jurisdictions; track jurisdiction) {
          <div class="jurisdiction-item">
            <mat-slide-toggle [checked]="isChecked(jurisdiction.jurisdictionCode)"
              (change)="onCheckedChange($event, jurisdiction)">
              &nbsp;&nbsp;&nbsp;{{ jurisdiction.jurisdictionFullName }}
            </mat-slide-toggle>
          </div>
        }
      </div>

      <div class="spacer-small"></div>

      <div class="validated-form-field-container">
        <lib-error-bubble [control]="searchCriteriaDetails.get('searchFromDate')!"
        [message]="jurisdictionsError$"></lib-error-bubble>
      </div>
    </mat-expansion-panel>
  </form>
</div>